import React from "react";
import { Outlet } from "react-router-dom";
// import { MailFilled } from "@ant-design/icons";
import { Layout } from "antd";
// import Logo from "../images/logo-api.png";

const { Content } = Layout;

function LayoutPage() {
    if (window.defaultroute === undefined) {
        window.defaultroute = "/";
    }

    return (
        <Layout>
            {/* A "layout route" is a good place to put markup you want to
            share across all the pages on your site, like navigation. */}
            {/* <Header>
                <img width={132} src={Logo} alt="" className="logo-header" />
            </Header> */}

            <Content>
                {/* An <Outlet> renders whatever child route is currently active,
                so you can think about this <Outlet> as a placeholder for
                the child routes we defined above. */}
                <div className="content-wrap">
                    <Outlet />
                </div>
            </Content>

            {/* <Footer>
                Copyright Group Danone @ 2023
                <Button type="link" href="mailto:" icon={<MailFilled />}>
                    Send Feedback
                </Button>
            </Footer> */}
        </Layout>
    );
}

export default LayoutPage;
